// removed by extract-text-webpack-plugin
module.exports = {"att-logo":"LogoLoader__att-logo","attLogo":"LogoLoader__att-logo"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/Loader/LogoLoader/LogoLoader.scss
// module id = 1705
// module chunks = 8